import { useState, useEffect, useMemo } from 'react';
import { Typography, Table, TableRow, TableCell } from '../../../tailwindcomponents';
import { ToolData } from '../../../types/tool';
import ToolsApi from '../../../api/tools';
import { useSearchParams } from "react-router-dom";

function LoanedToolForToLong() {
  const [searchParams] = useSearchParams();
  const location = (searchParams.get("location") ?? "").toLowerCase(); // "kef" | "rkv" | "other"
  const [loanedOutTools, setLoanedOutTools] = useState<ToolData[]>([]);

  const isKEF = (tool: ToolData) => {
    const bay = (tool.bay ?? "").toLowerCase();
    return (bay !== "other" && bay !== "rkv/line" && bay !== "unknown");
  };
  
  const isRKV = (tool: ToolData) => (tool.bay ?? "").toLowerCase() === "rkv/line";

  const isOther = (tool: ToolData) => {
    const bay = (tool.bay ?? "").toLowerCase();
    return (bay === "other" || bay === "unknown");
  };

  useEffect(() => {
    // Chrome is hidden by the shell for this route - see CHROMELESS_PATHS.
    ToolsApi.getAllLoanedToolsbyDays(0, "All positions", 0, "empty", true, false).then(res => {
      setLoanedOutTools(Array.isArray(res) ? res.filter(s => s.tool_to_long_in_circulations === true) : []);
    });
  }, []);

  // filter every render based on the current query param
  const filteredTools = useMemo(() => {
    const base = loanedOutTools ?? [];
    if (location === "kef") {
      return base.filter(isKEF);
    }
    if (location === "rkv") {
      return base.filter(isRKV);
    }
    if (location === "other") {
      return base.filter(isOther);
    }
    return base; // no/unknown param → show all
  }, [loanedOutTools, location]);

  const generateTableBody = (row: ToolData, index: number) => {
    return (
      <TableRow>
        <TableCell>{index}</TableCell>
        <TableCell>{row.employee_name}</TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell>{row.bay}</TableCell>
        <TableCell>{row.area}</TableCell>
        <TableCell>{row.serial}</TableCell>
        <TableCell>{row.out_date_text}</TableCell>
        <TableCell>{row.days_allowed}</TableCell>
      </TableRow>
    )
  }
  return (
    <div className="w-full">
      <div className="bg-red-600 py-4 rounded-lg">  <Typography color={'primary'} variant={'h1'} align={'center'} text={`Most wanted tools for ${location} (${filteredTools?.length})`} /></div>
      <Typography variant={'body1'} align={'center'} text={new Date().toLocaleString()} />
      <Table
        headers={["Name", "Description", "Bay", "Area", "Serial", "Loaned out", "Allowed Days"]}
        rows={filteredTools}
        generateBody={(row: ToolData, index: number) => generateTableBody(row, index)}
        pagination={false}
      />
    </div>
  );
};
export default LoanedToolForToLong